import { BaseAPI } from './BaseAPI.js'
import { FormAnswer } from '../types/index.js'

export default class FormAnswersAPI extends BaseAPI<FormAnswer> {
  override get resource(): string {
    return '/formAnswers'
  }
}
